export default __webpack_public_path__ + "static/media/garden3.6d233cd5.webp";